import axios from "axios";
import { generatePDF } from "./generateOrderCyclePDF";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const downloadStockOverview = async (orderCycle) => {
  try {
    const orderCycleCode = orderCycle.orderCycleCode;

    // Fetch latest order cycle details
    const response = await axios.get(
      `${API_BASE_URL}/orders/get-order-details-from-the-order-cycle/${orderCycleCode}`
    );

    const latestOrderCycle = response.data;
    console.log("Latest Order Cycle Details:", latestOrderCycle);

    // Call function to generate and download PDF (implement this separately)
    generatePDF(latestOrderCycle);
  } catch (error) {
    console.error("Error fetching latest order cycle details:", error);
    alert("Failed to fetch latest order cycle details.");
  }
};
